






























import Vue from 'vue';
import demosService, { DemoRow } from '@/services/demos.service';
import DemosDataTable from '@/components/demos/DemosDataTable.vue';
import CreateDemoModal from '@/components/demos/modals/CreateDemoModal.vue';

export default Vue.extend({
  name: 'DemosView',
  components: { DemosDataTable, CreateDemoModal },
  data() {
    return {
      loading: false, loadError: false, modalOpen: false, demos: [] as DemoRow[],
    };
  },
  mounted() {
    this.load();
  },
  methods: {
    async load() {
      this.loading = true;
      this.loadError = false;
      try {
        this.demos = await demosService.list();
      } catch {
        this.loadError = true;
        this.demos = [];
        this.$store.dispatch('snackbar/snackbarError', this.$t('demos.load_error'));
      } finally {
        this.loading = false;
      }
    },
    async onRevoke(item: DemoRow) {
      // eslint-disable-next-line no-alert
      if (!window.confirm(this.$t('demos.revoke_confirm') as string)) return;
      try {
        await demosService.patch(item.id, { revoke: true });
        this.$store.dispatch('snackbar/snackbarSuccess', this.$t('demos.revoked'));
        await this.load();
      } catch {
        this.$store.dispatch('snackbar/snackbarError', this.$t('demos.revoke_error'));
      }
    },
  },
});
